import api from "../../lib/api";

export const listJobs = async (signal, params) => (await api.get("/background-jobs", { signal, params, globalLoader: false })).data;
export const readJob = async (id, signal) => (await api.get(`/background-jobs/${encodeURIComponent(id)}`, { signal, globalLoader: false })).data;
export const readJobResult = async (id, signal) => (await api.get(`/background-jobs/${encodeURIComponent(id)}/result`, { signal, globalLoader: false })).data;
export const cancelJob = async id => (await api.post(`/background-jobs/${encodeURIComponent(id)}/cancel`, {}, { globalLoader: false })).data;
export const retryJob = async id => (await api.post(`/background-jobs/${encodeURIComponent(id)}/retry`, {}, { globalLoader: false })).data;
export const deleteJob = async id => (await api.delete(`/background-jobs/${encodeURIComponent(id)}`, { globalLoader: false })).data;

// Reopen current staging evidence, so replaced/committed previews stay locked.
export async function readUploadJob(job, signal) {
  const value = await readJobResult(job.id, signal);
  if (/^(legacy|installment)_(preview|refresh)$/.test(job.operation)) {
    const legacy = job.operation.startsWith("legacy_");
    const id = legacy ? value?.import_id : value?.id;
    if (!id) throw new Error("The saved job has no upload preview to reopen.");
    return (await api.get(`/bookings/legacy/${legacy ? "import" : "installments"}/${encodeURIComponent(id)}`,
      { signal, globalLoader: false })).data;
  }
  const previewPath = /^inventory_(upload|refresh)$/.test(job.operation) ? `/inventory/import/${encodeURIComponent(value?.import_id || "")}`
    : /^payment_(preview|refresh)$/.test(job.operation) ? `/finance/payments/import/${encodeURIComponent(value?.preview_id || "")}` : "";
  if (previewPath) {
    if (!(value?.import_id || value?.preview_id)) throw new Error("The saved job has no upload preview to reopen.");
    return (await api.get(previewPath, { signal, globalLoader: false })).data;
  }
  return value;
}
